import { Pipe, PipeTransform } from '@angular/core';

import { N_NLOW_ICONS } from '../constants';

@Pipe({ name: 'coverage' })
export class CoveragePipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    return N_NLOW_ICONS[value];
  }
}
